export default __webpack_public_path__ + "static/media/map.7d98ba39.png";